import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default (editor: Editor, opts: RequiredPluginOptions) => {
  const { block, label, id } = opts;

  if (block) {
    editor.Blocks.add("checkout", {
      media: `
<svg width="44" height="44" class="mx-auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 3H4.64357C5.11106 3 5.51616 3.32389 5.61905 3.77992L6.9187 9.54054M6.9187 9.54054L11.6614 30.5624C11.7643 31.0184 12.1694 31.3423 12.6369 31.3423H36.6151C37.0826 31.3423 37.4877 31.0184 37.5906 30.5624L42.0581 10.7606C42.1992 10.1353 41.7237 9.54054 41.0826 9.54054H6.9187Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.7153 42.0271C18.4107 42.0271 19.7851 40.684 19.7851 39.0271C19.7851 37.3702 18.4107 36.0271 16.7153 36.0271C15.0199 36.0271 13.6455 37.3702 13.6455 39.0271C13.6455 40.684 15.0199 42.0271 16.7153 42.0271Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M31.0409 42.0271C32.7363 42.0271 34.1106 40.684 34.1106 39.0271C34.1106 37.3702 32.7363 36.0271 31.0409 36.0271C29.3455 36.0271 27.9711 37.3702 27.9711 39.0271C27.9711 40.684 29.3455 42.0271 31.0409 42.0271Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21 18.9999L28 18.9999M28 18.9999L24.64 22.3599M28 18.9999L24.64 15.6399" stroke="#4E4E4E" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      label,
      category: "Pages",
      select: true,
      content: { type: "checkout" },
      ...block,
    });
  }
};
